module.exports = __webpack_public_path__ + "assets/img/box1Img.692dd3c6.png";